.button {
  border: 0;
  border-radius: 4px;
  font-weight: 600;
  letter-spacing: 0.02em;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.button:hover {
  transform: translateY(-1px);
  box-shadow: var(--shadow-soft);
}

.primary {
  background: var(--color-ember);
  color: #111;
}

.secondary {
  background: rgba(0, 0, 0, 0.55);
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.md {
  padding: 10px 22px;
  font-size: 0.85rem;
  text-transform: uppercase;
}

.lg {
  padding: 14px 32px;
  font-size: 0.95rem;
  text-transform: uppercase;
}
